import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Phone, ShieldCheck } from "lucide-react";
import { COMPANY, IMG } from "@/data/site";
import { useLead } from "@/context/LeadContext";

export default function FinalCTA() {
  const { openLead } = useLead();
  return (
    <section className="relative py-28 md:py-40 overflow-hidden bg-navy-deep" data-testid="final-cta">
      <div className="absolute inset-0">
        <img src={IMG.rain} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-deep via-navy-deep/85 to-royal/30" />
      </div>
      <div className="max-w-4xl mx-auto px-5 md:px-8 relative z-10 text-center">
        <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <ShieldCheck className="h-14 w-14 text-sky mx-auto shield-glow" />
        </motion.div>
        <h2 className="font-display text-4xl md:text-6xl font-extrabold text-white mt-6 leading-[1.05]">
          Don't wait for the next leak.<br /><span className="text-gradient-blue">Seal it today.</span>
        </h2>
        <p className="text-slate-300 mt-5 max-w-xl mx-auto">Book a free, no-obligation inspection. Our engineers will diagnose the exact problem and give you a transparent quote.</p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-9">
          <button onClick={() => openLead("book_inspection")} className="btn-ripple bg-royal hover:bg-royal/90 text-white font-semibold px-7 py-4 rounded-sm flex items-center gap-2 transition-colors" data-testid="finalcta-book">
            Book Free Inspection <ArrowRight className="h-4 w-4" />
          </button>
          <a href={`tel:${COMPANY.phoneRaw}`} className="glass text-white font-semibold px-7 py-4 rounded-sm hover:bg-white/10 transition-colors flex items-center gap-2">
            <Phone className="h-4 w-4 text-sky" /> {COMPANY.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
